import schema from '@/framework/logic/schema/set-components-map.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

const mapSetComponentsMap = action => ({
  type: 'LAYOUT_SET_COMPONENTS_MAP',
  payload: {
    value: action.data.value,
  },
});

const setComponentsMap = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapSetComponentsMap(
    validated(interpolate(meta.action, event, context))
  );
};

export default setComponentsMap;
